import { DefaultFieldDefinitionClientLogic } from "./default-field-def-client-logic";
import { FormField } from '../form-field.model';
import { AttachmentService } from "../../../services/attachment.service";
import { DomSanitizer } from "@angular/platform-browser";

export class AttachmentsFieldDefLogic extends DefaultFieldDefinitionClientLogic {

    public constructor(private attachmentService: AttachmentService, private sanitizer: DomSanitizer){
        super();
    }

    public includeInFormTemplateInstancesGrid(): boolean {
        return true;
    }

    public isATypeOfGridField(formField: FormField): boolean {
        return true;
    }

    public isDataGrid(): boolean {
        return true;
    }
    
    public getDisplayValueForFormsGridRow(row: object, columnDef: FormField) {
        let name: string = columnDef.name.toLowerCase();
        if(row['standard_attachment_id_column']){
            const id = parseInt(row['standard_attachment_id_column']);
            let url = this.attachmentService.viewFile(id);
            return `<a class="standard-attachment-column-in-forms-grid" style="text-decoration:underline" href="${url}" target="_blank">${row[name]}</a>`;
        }else{
            return row[name];
        }
    }

    public hasVirtualSiblingFormFieldsFor(formField: FormField): boolean {
        return true;
    }

    public getVirtualSiblingFormFieldsFor(formField: FormField): FormField[] {
        let virtualFormFields: FormField[] = [];

        const attachmentId = new FormField();
        attachmentId.name = 'standard_attachment_id_column';
        attachmentId.displayName = 'AttachmentId';
        attachmentId.id = parseInt(`${formField.id}9`);
        virtualFormFields.push(attachmentId);

        const title = new FormField();
        title.name = 'standard_attachment_title_column';
        title.displayName = 'AttachmentTitle';
        title.id = parseInt(`${formField.id}1`);
        virtualFormFields.push(title);

        const fileName = new FormField();
        fileName.name = 'standard_attachment_file_name_column';
        fileName.displayName = 'AttachmentFileName';
        fileName.id = parseInt(`${formField.id}2`);
        virtualFormFields.push(fileName);

        return virtualFormFields;
    }
}
